let pageConfig = {};

// 列表展示项
pageConfig.listColumns = [
    {
        label: '充电桩IMEI码',
        props: 'pileCode',
        minWidth: 200,
    },
    {
        label: '订单编号',
        props: 'orderNo',
        minWidth: 200,
        tooltip: true,
    },
    {
        label: '用户手机号',
        props: 'custPhone',
        minWidth: 200,
    },
    {
        label: '订单类型',
        props: 'sourceName',
        minWidth: 120,
    },
    {
        label: '订单状态',
        props: 'chargeStepName',
        minWidth: 200,
    },
    {
        label: '订单属性',
        props: 'orderPropertyName',
        minWidth: 120,
    },
    {
        label: '开始时间',
        props: 'beginTime',
        minWidth: 200,
    },
    {
        label: '结束时间',
        props: 'endTime',
        minWidth: 200,
    },
    {
        label: '充电日期',
        props: 'chargeDay',
        minWidth: 200,
    },
    {
        label: '充电时长',
        props: 'chargeMin',
        minWidth: 180,
    },
    {
        label: '充电量（kW·h）',
        props: 'chargeVal',
        minWidth: 180,
        sortable: true,
    },
    {
        label: '私人/公共',
        props: 'pileTypeName',
        minWidth: 120,
    },
    {
        label: '交流/直流',
        props: 'currentOutTypeName',
        minWidth: 120,
    },
    {
        label: '枪头',
        props: 'gunPort',
        minWidth: 80,
    },
    {
        label: '桩型号',
        props: 'pileTypeCode',
        minWidth: 180,
    },
    {
        label: '厂商标识',
        props: 'manufactureMark',
        minWidth: 180,
    },
    {
        label: '桩软件版本',
        props: 'softVersion',
        minWidth: 180,
    },

];

// // 面包屑
pageConfig.listBreadCrumb = [{
    type: 'title',
    name: '首页',
}, {
    type: 'title',
    name: '运营分析',
},
    {
    type: 'title',
    name: '用户数据信息',
},
{
    type: 'title',
    name: '活跃用户报表'
},  ];

// 列表-表格属性
pageConfig.tableConfig = {
    showSelection: false,
    showIndex: false,
};

// 列表-分页参数
pageConfig.pagination = {
    current: 1,
    total: 0,
    pageSize: 10,
    pageSizes: [10, 20, 50, 100],
}
// 列表-编辑操作
pageConfig.tableEditObj = {
    editKey: 'id',
    editRouter: 'pileModelDetail',
};

// 路由
pageConfig.listRouter = 'orderManageList';

pageConfig.orderDeatilRouter = 'orderDetail';

// 详情的面包屑
pageConfig.detailBreadCrumb = [{
    type: 'title',
    name: '首页',
},
{
    type: 'router',
    name: '充电订单管理',
    router: 'orderManageList'
},
{
    type: 'title',
    name: '订单详情',
}];

pageConfig.formRules = {
    refundStatus: [{
        required: true,
        message: '请选择是否退款',
        trigger: 'change'
    }],
    toCustReceipt: [{
        required: true,
        message: '请填写车主回执',
        trigger: 'blur'
    }],
    freeServiceFee: [{
        required: true,
        message: '请填写服务费免征额',
        trigger: 'blur'
    }],
    serviceReceipt: [{
        required: true,
        message: '请填写运营商回执',
        trigger: 'blur'
    }],
};

pageConfig.orderFormRules = {
    chargeOverReason: [{
        required: true,
        message: '请填写结束充电原因',
        trigger: 'change'
    }]
};

export default pageConfig;
